import { defineMessages } from "react-intl";

import {
	accessTypeMessages,
	validator
} from "lib/build/forms/ktx/basic-registration-data/waiting-list-data/access";

import { FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	access: {
		id: "ktx.form.access.title",
		defaultMessage: "Jelenlegi vérnyerés, vagy egyéb dialízis katéter"
	},
	accessType: {
		id: "ktx.form.access.value",
		defaultMessage: "Típusa"
	},
	other: {
		id: "ktx.form.access.other",
		defaultMessage: "Egyéb"
	},
	comment: {
		id: "ktx.form.access.comment",
		defaultMessage: "Megjegyzés"
	}
});

const fieldset: FieldsetData = {
	rows: [
		{
			columns: [
				{
					width: 12,
					field: {
						type: "field",
						path: ["accessType"],
						label: messages.accessType,
						errorMessages: genericErrorMessages,
						input: {
							type: "select",
							props: {
								labels: accessTypeMessages
							}
						}
					}
				}
			]
		},
		{
			columns: [
				{
					width: 12,
					field: {
						type: "field",
						path: ["accessTypeOther"],
						label: messages.other,
						errorMessages: genericErrorMessages,
						input: {
							type: "textarea",
							props: {}
						}
					}
				}
			]
		},
		{
			columns: [
				{
					width: 12,
					field: {
						type: "field",
						path: ["comment"],
						label: messages.comment,
						errorMessages: genericErrorMessages,
						input: {
							type: "textarea",
							props: {}
						}
					}
				}
			]
		}
	]
};

export const node: LeafNode = {
	id: "ktx_access",
	value: {
		schemaId: "access",
		title: messages.access,
		validator,
		fieldset,
		applyCurrentDate: false
	}
};
